import { type ITrackingProps, TRACKING_ACTIONS, TRACKING_CATEGORIES, TRACKING_EVENTS } from '@cx-web/feature-tracking';

import { type TrackBet } from './types';

/**
 * Build the BET_SLIP_VIEW tracking payload from a betslip.
 *
 * Pure by design: it returns the event object rather than dispatching it, so each caller hands it to
 * its own `eventTracking` (the context path uses a `new TrackingActions()` instance; the store-backed
 * MiniBetslipFromStore uses the `trackingActions` singleton). Keeping the payload shape here makes it
 * the single source of truth for both header variants, so they emit byte-identical analytics and the
 * store path can't silently drift into a tracking regression. See NGF-6313.
 */
export const buildBetSlipViewEvent = (betSlip: TrackBet[], stake?: number): ITrackingProps => {
  const isAcca = betSlip.length > 1;

  return {
    event: TRACKING_EVENTS.BET_SLIP_VIEW,
    eventCategory: TRACKING_CATEGORIES.BETTING,
    eventAction: TRACKING_ACTIONS[TRACKING_EVENTS.BET_SLIP_VIEW],
    eventLabel: isAcca ? 'multi_bets' : 'single_bet',
    accumulator: isAcca ? 'yes' : 'no',
    marketName: betSlip.map(b => b.marketName).join(','),
    subeventName: betSlip.map(b => b.subeventName).join(','),
    bookieCode: betSlip.map(b => b.bestOddsBookmakers).join(','),
    betName: betSlip.map(b => b.name).join(','),
    betOdds: betSlip.map(b => (b.bestOddsUs ? b.bestOddsUs : b.bestOddsDecimal)).join(','),
    betStake: stake?.toString(),
  };
};
